/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from '@emotion/core';
import { useContext, useRef } from 'react';

import UploadContext from '~src/contexts/UploadContext';
import DetailedUploadPanel from './DetailedUploadPanel';
import { CollapseProps } from 'antd/lib/collapse';
import { shouldUseBulkUploadMode } from '~src/utils/bulkUploadUtils';
import BulkUploadPanel from '~components/atoms/UploadPanel/BulkUploadPanel';

export interface UploadPanelProps {
  /** Collapse state change callback */
  onCollapse?: CollapseProps['onChange'];
  mobile?: boolean;
}

const UploadPanel: React.FC<UploadPanelProps> = ({ onCollapse, mobile }) => {
  const { uploadContext } = useContext(UploadContext);
  const skipDetailedCleanupRef = useRef(false);

  const isBulkMode = shouldUseBulkUploadMode(uploadContext);

  if (isBulkMode) {
    skipDetailedCleanupRef.current = true;

    return <BulkUploadPanel onCollapse={onCollapse} mobile={mobile} />;
  }

  skipDetailedCleanupRef.current = false;

  return (
    <DetailedUploadPanel
      onCollapse={onCollapse}
      mobile={mobile}
      skipCleanupRef={skipDetailedCleanupRef}
    />
  );
};

export default UploadPanel;
